export default __webpack_public_path__ + "static/media/Prabu.97b85960.png";